"use client";

import { captureException } from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";
export default function GlobalError({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);
  return <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
         definition requires a `statusCode` prop. However, since the App Router
         does not expose status codes for errors, we simply pass 0 to render a
         generic error message. */}
        <NextError statusCode={0} data-sentry-element="NextError" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>;
}

// Recycled

// 20 May 2025

// return <ErrorMessageView title="Something went wrong" description="Failed to load the blog. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the user profile. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the course. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the course. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load blogs. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the course. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load mock reviews. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the dashboard. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the profile. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load blogs. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the courses. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load payments. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load blogs. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load chapter. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load chapters list. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load chapters list. Please try again later." />
// return <ErrorMessageView title="Something went wrong" description="Failed to load the courses. Please try again later." />
// return <StatusText variant="error">Failed to load profile data</StatusText>
// return <StatusText variant="error">Failed to load leaderboard.</StatusText>
// return { success: false, error: error instanceof Error ? error.message : DB_GENERAL_ERROR_MESSAGE }
// return NextResponse.json({ error: DB_GENERAL_ERROR_MESSAGE }, { status: 500 });
// return <CenteredContent><StatusText variant="error">Could not fetch the page</StatusText></CenteredContent>
// return userNotFoundMetadata